(function($) {
  // DOCUMENT READY
  $(document).ready(function() {
    const Sentry = require(`@sentry/browser`);
    const icons = require(`./modules/icons`);
    const secondaryNav = require(`./modules/secondary-nav`);
    const fadeInDefault = require(`./modules/fade-in-default`);
    const locationDropDown = require(`./modules/location-drop-downs`);
    const locker = require(`./modules/locker`);
    const editPublic = require(`./modules/profile/edit-profile`);
    const editProfilePublic = require(`./modules/profile/edit-profile-public`);
    const editTheme = require(`./modules/profile/edit-profile-theme`);
    const login = require(`./modules/login/login`);
    const resetPassword = require(`./modules/login/reset-password`);
    const createNewPassword = require(`./modules/login/create-new-password`);
    const folders = require(`./modules/folders`);
    const follow = require(`./modules/Follow`);
    const editclub = require(`./modules/edit-club`);
    const editTeam = require(`./modules/edit-team`);
    const createClub = require(`./modules/create-club`);
    const createTeam = require(`./modules/create-team`);
    const clubColours = require(`./modules/club-colours`);
    const favourite = require(`./modules/favourite`);
    const sessions = require(`./modules/sessions`);
    const mySessions = require(`./modules/my-sessions`);
    const manageMembers = require(`./modules/manage-members`);
    const questionnaire = require(`./modules/questionnaire`);
    const calendar = require(`./modules/calendar`);
    const seasonPlan = require(`./modules/season-plan`);
    const seasonPlanSales = require(`./modules/season-plan-sales`);
    const activityFeed = require(`./modules/activity-feed`);
    const contentFilter = require(`./modules/content-filter`);
    const panels = require(`./modules/panels`);
    try {
      if (process.env.SENTRY_DSN) {
        Sentry.init(
          {
            dsn: process.env.SENTRY_DSN,
            environment: process.env.SENTRY_ENVIRONMENT,
            release: process.env.SENTRY_RELEASE,
          },
        );
      } else {
        // eslint-disable-next-line no-console
        console.log(`Sentry DSN not set`);
      }
    } catch (e) {
      // if for some reason the sentry info is wrong we don't want to kill the entire bundle
      // eslint-disable-next-line no-console
      console.error(e);
    }
  });
  // end document ready
}(jQuery));



// WEBPACK FOOTER //
// ./library/js/main.js